import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src2384714272/src/cf-tool-frontend/app/collaboration/CollaborationPageClient.jsx");
